import { P0, S, abs, fillAt, max, quad, rotPts } from '../../geometry';

export const acorn = {
  name: 'Acorn',
  colors: ['#E3A008', '#C46A3E'],
  draw(m, t) {
    let tip = 2 * S(t * 1.2),
      sw = 8 * S(t * 1.5),
      up = 0,
      pose = P0();
    if (m === 'happy') {
      tip = 8 * S(t * 6);
      sw = 26 * S(t * 9);
      up = -2 * abs(S(t * 6));
      pose.ty = -3 * abs(S(t * 6));
    }
    // Thinking: the cap keeps tipping side to side like a hat, the stalk swinging behind it.
    if (m === 'thinking') {
      tip = 11 * S(t * 2);
      sw = 30 * S(t * 2 - 1);
    }
    if (m === 'talking') {
      up = -3 * max(0, S(t * 10));
      sw = 10 * S(t * 10);
    }
    if (m === 'surprised') {
      up = -7;
      tip = 2 * S(t * 22);
      sw = 0;
    }
    if (m === 'paused') {
      tip = -14 + S(t * 0.7);
      up = 2;
      sw = -30;
      pose.ty = 2;
    }
    const nut = [
      [25, 44],
      ...quad([25, 44], [24, 80], [50, 88], 7).slice(1),
      ...quad([50, 88], [76, 80], [75, 44], 7).slice(1),
      [50, 46],
      [25, 44],
    ];
    const capPts = [
      [19, 48],
      ...quad([19, 48], [21, 25], [50, 24], 6).slice(1),
      ...quad([50, 24], [79, 25], [81, 48], 6).slice(1),
      ...quad([81, 48], [50, 53], [19, 48], 5).slice(1),
    ];
    const piv = [tip > 0 ? 78 : 22, 48],
      mv = (p) => p.map(([x, y]) => [x, y + up]);
    const cap = rotPts(mv(capPts), piv[0], piv[1] + up, tip);
    const stalk = rotPts(
      rotPts(
        mv([
          [50, 25],
          [51, 18],
          [55, 14],
        ]),
        50,
        25 + up,
        sw
      ),
      piv[0],
      piv[1] + up,
      tip
    );
    return {
      strokes: [
        { c: 'a', pts: nut, n: 30 },
        { c: 'b', pts: stalk },
        { c: 'b', pts: cap, n: 30 },
      ],
      eyes: { x: 50, y: 63 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0, 2),
};
